/** @format */

import template from './gb-edit-honour-roll-widget.html';
import './gb-edit-honour-roll-widget.scss';

import _ from 'lodash';

export const GbEditHonourRollWidgetComponent = {
    template,
    require: {
        gbApp: '^^',
        gbEditTools: '^^',
        gbAddHonourRollWidget: '^^',
    },
    bindings: {
        widget: '=',
    },
    controller: class GbEditHonourRollWidgetComponent {
        constructor($gbEditTableItemsDialog, $gbItem, $ccToast, $rootScope, $ccLoading, LoadingHelper) {
            'ngInject';

            this.$gbEditTableItemsDialog = $gbEditTableItemsDialog;
            this.$gbItem = $gbItem;
            this.$ccToast = $ccToast;
            this.cardsOnView;
            this.$rootScope = $rootScope;

            this.loadingHelper = new LoadingHelper();
            this.isLoading = () => this.loadingHelper.isLoading();
            this.getLoadingMessage = () => this.loadingHelper.getFirstMessage();
            this.loadingWatcher = $ccLoading.bind(this.isLoading, this.getLoadingMessage);
        }

        $onInit() {
            if (this.isHorizontalScroll()) {
                this.cardsOnView = this.widget.columns;
                this.widget.rows = 1;
            } else {
                this.cardsOnView = this.widget.rows;
                this.widget.columns = 1;
            }
        }

        isHorizontalScroll() {
            return this.widget.transition === 'scroll-left' || this.widget.transition === 'scroll-right';
        }

        getItems() {
            return this.$gbItem.cache.query({
                auction: this.gbApp.getAuctionUrl(),
                is_visible: true,
            });
        }

        editTableItems() {
            let data = {
                widget: this.widget,
                items: this.getItems(),
            };

            return this.$gbEditTableItemsDialog.show(data).then((hiddenUuids) => {
                this.widget.hidden_items = hiddenUuids;
                this.gbEditTools.saveWidget();
            });
        }

        validateLatestActivities() {
            if (this.isHorizontalScroll()) {
                this.widget.columns = this.cardsOnView;
                this.widget.rows = 1;
            } else {
                this.widget.rows = this.cardsOnView;
                this.widget.columns = 1;
            }

            if (this.widget.latest_activities < this.cardsOnView) {
                this.$ccToast.error(`Latest Activity Quantity must be higher than ${this.cardsOnView}`);
                return;
            }

            const loader = this.loadingHelper.push('SAVING');
            this.gbEditTools.saveWidget().finally(() => {
                loader();
            });
        }

        showPreview() {
            this.previewHonourRoll = {
                widget: this.widget.uuid,
            };
            this.$rootScope.$broadcast(this.gbApp.$honourRollPreviewEvent, this.previewHonourRoll);
        }
    },
};
